import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Avatar } from 'avatar-components/Avatar';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tag } from 'foundations-components/transitional/components/Tag';
import ChickletAssociationLabels from '../ChickletAssociationLabels';
import { Flex } from 'foundations-components/components/Flex';
import { isTrellisTheme, useTheme } from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledDiv = styled.div.withConfig({
  displayName: "AssociationChicklet__StyledDiv",
  componentId: "bb4g66-0"
})(["vertical-align:top;margin:", ";"], ({
  $isTrellis
}) => $isTrellis ? '12px 0 -4px 0px' : '-1px 0 0 -13px');
const StyledSpan = styled.div.withConfig({
  displayName: "AssociationChicklet__StyledSpan",
  componentId: "bb4g66-1"
})(["float:right;padding-top:3px;padding-left:10px;"]);
const AssociationChicklet = ({
  associationDefinitions,
  avatarProps,
  children,
  isPrimary = false,
  primaryIdentifier
}) => {
  const theme = useTheme();
  const isTrellis = isTrellisTheme(theme);
  const renderAvatar = () => {
    return (
      /*#__PURE__*/
      // @bend-expect trellis-tokenized
      _jsx(StyledSpan, {
        "data-selenium-test": "chicklet-avatar",
        "data-test-id": "chicklet-avatar",
        children: /*#__PURE__*/_jsx(Avatar, Object.assign({}, avatarProps))
      })
    );
  };
  const renderPrimaryIdentifier = () => {
    if (!primaryIdentifier) {
      return null;
    }
    return /*#__PURE__*/_jsx("div", {
      "data-selenium-test": "chicklet-primary-identifier",
      "data-test-id": "chicklet-primary-identifier",
      children: primaryIdentifier
    });
  };
  return /*#__PURE__*/_jsxs("div", {
    children: [isPrimary &&
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(StyledDiv, {
      $isTrellis: isTrellis,
      children: /*#__PURE__*/_jsx(Tag, {
        use: "default",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          "data-selenium-test": "chicklet-primary-tag",
          "data-test-id": "chicklet-primary-tag",
          message: "cardAssociatedObjects.chicklet.chickletPrimaryTag"
        })
      })
    }), avatarProps && renderAvatar(), renderPrimaryIdentifier(), /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      children: [children, /*#__PURE__*/_jsx(ChickletAssociationLabels, {
        associationDefinitions: associationDefinitions
      })]
    })]
  });
};
AssociationChicklet.propTypes = {
  associationDefinitions: PropTypes.array.isRequired,
  avatarProps: PropTypes.object,
  children: PropTypes.node,
  isPrimary: PropTypes.bool,
  primaryIdentifier: PropTypes.node
};
export default AssociationChicklet;